
/**
 * A hacky workaround for theme/flickity limitations to enable filtering any variant-specific media
 * from the gallery, while allowing non variant-specific media to remain.
 */
function filterVariantMedia(flktyGallery, sku) {
    let galleryImages = document.querySelectorAll('.Product__Slideshow .Carousel__Cell');

    // Override the flickity instance select() 
    // method for just this carousel, to loop/jump media to next variant-specific or general element
    flktyGallery.select = function(index, isWrap) {
        // When a variant change occurs, theme js calls select() explicitly passing the second parameter as false
        // This condition makes a hacky determination of whether or not to loop/jump to the next 'valid' media for the variant
        // Basically, it it's a variant selection, or if the next media is 'valid', ignore the override logic
        if (isWrap === false) {
            return Flickity.prototype.select.apply(this, arguments);
        }
        const media = galleryImages[index];
        const imageVariant = media?.dataset.imageVariant?.toLowerCase();
        const skuMatches = sku === imageVariant;
        if (skuMatches) {
            return Flickity.prototype.select.apply(this, arguments)
        } 

        const arr = Array.from(galleryImages);
        if (index > flktyGallery.selectedIndex) {
            const firstVariantMedia = arr.find(m => m.dataset.imageVariant?.toLowerCase() === sku);
            const indexForNavigate = arr.indexOf(firstVariantMedia)
            arguments[0] = indexForNavigate;
            return Flickity.prototype.select.apply(this, arguments)
        }
        if (index < flktyGallery.selectedIndex) {
            const lastVariantMedia = arr.findLast(m => m.dataset.imageVariant?.toLowerCase() === sku);
            const indexForNavigate = arr.indexOf(lastVariantMedia)
            arguments[0] = indexForNavigate;
            return Flickity.prototype.select.apply(this, arguments)
        }
        return Flickity.prototype.select.apply(this, arguments)
    }

}

function toggleVariantThumbnails() {
    let gallery = document.querySelector('.Product__Slideshow');
    let flktyGallery = Flickity.data(gallery);
    document.addEventListener('variant:changed', function(event) {

        let variant = event.detail.variant;
        let navScroller = document.getElementsByClassName('Product__SlideshowNavScroller')[0];


        navScroller.classList.add('is-hidden');
        flktyNav.deactivate();

        if (variant) {
            let sku = variant.sku.toLowerCase(),
                thumbs = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage'),
                hasThumb = document.querySelectorAll('.Product__SlideshowNav .Product__SlideshowNavImage[data-image-variant="'+ sku +'"]').length;

            filterVariantMedia(flktyGallery, sku);

            if (hasThumb) {
                thumbs.forEach( function(thumb) {
                    if (sku === thumb.dataset.imageVariant.toLowerCase()) {
                        thumb.classList.remove('hidden-tablet-and-up');
                    } else {
                        thumb.classList.add('hidden-tablet-and-up');
                    }    
                });
            } else {
                thumbs.forEach( function(thumb) {
                    thumb.classList.remove('hidden-tablet-and-up');
                });
            }
        }

        flktyNav.activate();
        window.flktyGallery = flktyGallery;
        setTimeout(function () {
            navScroller.classList.remove('is-hidden');
        }, 750);
    });
}

document.addEventListener('DOMContentLoaded', function() {
    toggleVariantThumbnails();
    const gallery = document.querySelector('.Product__Slideshow');
    const initialSku = gallery.dataset.initialSku;
    const flktyGallery = Flickity.data(gallery);
    filterVariantMedia(flktyGallery, initialSku)
});

document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
    var dealerButton = document.querySelector('.Button--dealer');
    var dealerButtonSpan = document.querySelector('.Button--dealer span');

    if (variant == null) {
      dealerButtonSpan.textContent = 'Unavailable';
      dealerButton.setAttribute('disabled', '');
    } else {
      dealerButtonSpan.textContent = 'Dealer Locator';
      dealerButton.removeAttribute('disabled', '');
    }
});
